import Vue from 'vue';
import vuestore from '@/store';

import camera from "./components/camera.vue"
import slideShow from "./components/slideShow.vue"
import { mediaStore, MediaStore } from './store/media.store';


Vue.component('camera', camera);
Vue.component('slideShow', slideShow);


export const mediaConfiguration = {
  defaultWidth: 200,
  defaultHeight: 200,
}

export function init() {
  vuestore.registerModule(MediaStore.PREFIX, MediaStore);
}